module.exports = "https://r.zoocdn.com/_next/static/images/location-99703c9389746e796b03551e4f78508f.svg";